import React from 'react';

function Faq(
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      {...props}
    >
      <mask
        id='a'
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits='userSpaceOnUse'
        style={{
          maskType: 'alpha'
        }}
      >
        <path fill='#D9D9D9' d='M0 0h24v24H0V0Z' />
      </mask>
      <g fill='#858585' mask='url(#a)'>
        <path d='m4.5 17.42-2.3 2.3c-.317.317-.68.387-1.088.212-.408-.175-.612-.487-.612-.937V3.42c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 2.5 1.42h16c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413v12c0 .55-.196 1.02-.587 1.412a1.926 1.926 0 0 1-1.413.588h-14Zm-.85-2H18.5v-12h-16v13.125l1.15-1.125Z' />
        <path d='m21.8 22.72-2.3-2.3h-13a1 1 0 1 1 0-2h13.85l1.15 1.125V7.42a1 1 0 0 1 2 0v14.575c0 .45-.204.762-.613.937-.408.175-.77.105-1.087-.212Z' />
        <path d='M15.822 12.78a.3.3 0 0 1-.257-.144l-.388-.64a2.182 2.182 0 0 1-.371.028c-.467 0-.896-.11-1.288-.329a2.468 2.468 0 0 1-.924-.91 2.525 2.525 0 0 1-.343-1.308c0-.486.114-.922.343-1.31.229-.387.537-.688.924-.902.392-.22.821-.33 1.288-.33.467 0 .894.11 1.281.33.387.214.693.515.917.903.229.387.343.823.343 1.309 0 .396-.077.762-.231 1.098a2.49 2.49 0 0 1-.637.848l.653.879a.3.3 0 0 1-.241.479h-1.07Zm-1.989-3.303c0 .336.084.604.252.804.168.196.408.294.721.294.308 0 .546-.098.714-.293.168-.201.252-.47.252-.805 0-.341-.084-.61-.252-.805-.168-.201-.406-.301-.714-.301-.313 0-.553.1-.721.3-.168.197-.252.465-.252.806ZM10.643 11.433a.3.3 0 0 0-.285-.207H9.141a.3.3 0 0 0-.285.207l-.087.267a.4.4 0 0 1-.38.276H7.62a.4.4 0 0 1-.376-.538l1.52-4.156a.4.4 0 0 1 .376-.262h1.233a.4.4 0 0 1 .376.263l1.514 4.156a.4.4 0 0 1-.376.537h-.776a.4.4 0 0 1-.38-.276l-.088-.267Zm-.72-1.376a.2.2 0 0 0 .19-.261l-.173-.532a.2.2 0 0 0-.38 0l-.173.532a.2.2 0 0 0 .19.261h.346ZM6.991 7.02a.3.3 0 0 1 .3.3v.632a.3.3 0 0 1-.3.3H5.645a.3.3 0 0 0-.3.3v.086a.3.3 0 0 0 .3.3h.8a.3.3 0 0 1 .3.3v.569a.3.3 0 0 1-.3.3h-.8a.3.3 0 0 0-.3.3v1.268a.3.3 0 0 1-.3.3h-.954a.3.3 0 0 1-.3-.3V7.32a.3.3 0 0 1 .3-.3h2.9Z' />
      </g>
    </svg>
  );
}

Faq.displayName = 'Faq';

export default Faq;
